import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { Samv2Module, TemplateService } from '@aubert-et-duval/samv2';

@Component({
    selector: 'app-home',
    imports: [CommonModule, MatCardModule, TranslateModule, Samv2Module],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    constructor(
        private templateService: TemplateService
    ) { }

    ngOnInit() {
        this.templateService.setTemplateParameters(
            {
                ShowMenuButton: true,
                NavBarVisible: true
            });
    }
}
